import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { PacientesService } from '../../services/pacientes/pacientes.service';
import { ToastrService } from 'ngx-toastr';
import { BaseComponent } from 'src/app/models/base-component';
import { GlobalVariable } from 'src/app/global';
import { Util } from 'src/app/utils/utils';
import { PdfService } from 'src/app/base/services/pdf/pdf.service';

declare const PDFDocument:any;
declare const blobStream:any;
declare const aplicarEditor:any;

@Component({
    selector: 'app-recetas',
    templateUrl: './recetas.component.html',
    styleUrls: ['./recetas.component.css'],
    standalone: false
})
export class RecetasComponent extends BaseComponent implements OnInit {

  receta:any;
  historia_paciente:any;
  paciente:any;
  especialidad_especialista:any;
  historias_paciente:any[]=[];
  util:any=Util;
  vista:string="";
  @Output() alTerminar:EventEmitter<any>  = new EventEmitter<any>();
  aplicacion_pacientes:any;

  constructor(public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    public pacientesService:PacientesService,
    public pdfService:PdfService,
    private toastr: ToastrService) {
      super(persistenciaService,modalService,generalService,usuarioService);
    }

  ngOnInit(): void {
    this.init();
    this.aplicacion_pacientes= this.usuario.aplicacionesUsuario.filter(app_usuario => app_usuario.aplicacion.codigo==GlobalVariable.Dictionary.CODIGO_APP_PACIENTES)[0];
    this.aplicacion_pacientes= this.vista=="citas"?{puede_modificar:true}:this.aplicacion_pacientes;
    if(this.paciente && this.paciente.id){
      let hoy=new Date();
      this.filter={
        id_paciente:this.paciente.id,
        fecha_inicio:null,
        fecha_fin:{ year:hoy.getFullYear(), month:(hoy.getMonth()+1), day:hoy.getDate() }
      };
      this.buscarHistorialPaciente();
    }
    if(this.historia_paciente.descripcion==null){
      this.historia_paciente.descripcion="<p><b>Motivo de Consulta</b></p><ul><li><b>Antecedentes:</b></li><li><b>Medicamentos Actuales:</b></li><li><b>Alergias:</b></li><li><b>Enfermedades Actuales:</b></li><li><b>Signos Vitales:</b></li><li><b>Exploración Física:</b><ul><li><b>Laboratorios</b></li><li><b>Estudios de imágenes</b></li></ul></li><li><b>Observación</b></li></ul>";
    }
  }

  ngAfterViewInit() {
    aplicarEditor(this);
  }

  agregarReceta(receta){
    if(this.validarReceta(receta)){
      this.historia_paciente.recetas=this.historia_paciente.recetas?this.historia_paciente.recetas:[];
      this.historia_paciente.recetas.push(receta);
      this.receta={
        id_historia_paciente:this.historia_paciente.id
      } 
    }
  }

  establecerDescripcion(dato){
    this.historia_paciente.descripcion=dato;
  }

  validarReceta(receta){
    let res=true;
    if(!receta.medicamento){
      res=res && false;
      this.toastr.error("Debe especificar el medicamento!");
    }
    if(!receta.cantidad){
      res=res && false;
      this.toastr.error("Debe especificar la cantidad!");
    }
    if(!receta.indicacion){
      res=res && false;
      this.toastr.error("Debe especificar la indicacion!");
    }
    return res;
  }

  guardarReceta(){
    //if(this.historia_paciente.recetas.length>0){
      this.blockUI.start();
      this.pacientesService.guardarReceta(this.historia_paciente.id,this.historia_paciente).subscribe((res:any)=>{
        this.blockUI.stop();
        this.cerrarComponente();
        this.toastr.success(res.mensaje);
      })
    /*}else{
      this.toastr.error("Debe existir al menos una receta!");
    }*/
  }

  eliminarReceta(receta){
    if(receta.id){
      receta.eliminado=true;
    }else{
      this.historia_paciente.recetas.splice(this.historia_paciente.recetas.indexOf(receta),1);
    }
  }

  cerrarComponente(){
    this.alTerminar.emit();
  }

  buscarHistorialPaciente(){
    this.blockUI.start();
    this.pacientesService.obtenerHistoriasPaciente(this).subscribe((res:any)=>{
      this.blockUI.stop();
      this.historias_paciente=res.historias_paciente;
    });
  }

  verMedicamentosHistoria(h){
    h.mostrar_medicamentos=!h.mostrar_medicamentos;
    if(h.mostrar_medicamentos && !h.medicamentos_cargados){
      h.cargando_medicamentos=true;
      this.pacientesService.obtenerReceta(h.id_historia_paciente).subscribe((res:any)=>{
        h.medicamentos=(res||[]).filter(r => !r.eliminado);
        h.medicamentos_cargados=true;
        h.cargando_medicamentos=false;
      });
    }
  }

  generarPdfReceta(){
    this.pdfService.imprimirRecetaClinica(this.historia_paciente,this.paciente,this.usuario);
  }

  generarPdfRecetaPreimpresa(){
    this.pdfService.imprimirRecetaPreimpresa(this.historia_paciente,this.paciente,this.usuario);
  }

  edadPaciente(){
    let persona=(this.paciente && this.paciente.cliente)?this.paciente.cliente.persona:null;
    return (persona && persona.fecha_nacimiento)?Util.calcularEdad(persona.fecha_nacimiento):null;
  }

}
